'use client';

import { vars } from '@/theme/vars.css';
import { FormControl, Select, SelectChangeEvent } from '@mui/material';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import Grid from '../ui/Grid';
import Txt from '../ui/Txt';
import { FilterSliceState } from './entryIndexTypes';
import { useEntryIndexFilter } from './useEntryIndexFilter';

export type EntryIndexFilterProps = {
  filterId: string;
};

const EntryIndexFilter = ({ filterId }: EntryIndexFilterProps) => {
  const { itemTree, clear, add } = useEntryIndexFilter(filterId);
  const [value, setValue] = useState<string>('');
  const t = useTranslations('entryIndex');
  const labelId = `${filterId}-label`;

  const handleChange = (event: SelectChangeEvent) => {
    const next = event.target.value;
    setValue(next);
    clear();
    if (next) add(next);
  };

  return itemTree.length ? (
    <FormControl fullWidth>
      <Txt id={labelId} as="label" htmlFor={filterId} variant="body" autoMargin>
        {t('filterBy')}
      </Txt>
      <Select
        native
        id={filterId}
        value={value}
        variant="filled"
        onChange={handleChange}
        disableUnderline
        style={{
          borderWidth: '1px',
          borderColor: vars.palette.colorSets.full.contrastText,
          borderStyle: 'solid',
        }}
        sx={{
          '& select': {
            paddingTop: vars.spacing['3xs'],
            paddingBottom: vars.spacing['3xs'],
          },
          '& select:focus-visible': {
            outline: '2px solid currentColor',
            outlineOffset: '2px',
          },
        }}>
        <option value="">{t('filterDefault')}</option>
        {itemTree.map((item) => (
          <option key={item.id} value={item.id}>
            {item.title}
          </option>
        ))}
      </Select>
    </FormControl>
  ) : null;
};

const EntryIndexFilters = ({ filters }: { filters: FilterSliceState[] }) => {
  return filters.map((filter) => {
    return (
      <Grid.Col key={filter.id} md={3}>
        <EntryIndexFilter filterId={filter.id} />
      </Grid.Col>
    );
  });
};

export default EntryIndexFilters;
